import { FormField, FormService } from '../services/formService';
import { Validations, Validators } from '../services/validations';
import { BaseModel } from './baseModel';

export class RegistrationModel extends BaseModel{
  selectedTab: FormField;
  username: FormField;
  password: FormField;
  confirm_password: FormField;
  school_code: FormField;
  emp_id: FormField;
  student_id: FormField;
  branch_code: FormField;
  constructor() {
    super();
    this.selectedTab = new FormField(1, true);
    this.username = new FormField("", true, [Validations.EMPTY]);
    this.password = new FormField("", true, [Validations.EMPTY, [Validations.LENGTH, 5, 20]]);
    this.confirm_password = new FormField("", true, [Validations.EMPTY, [Validations.LENGTH, 5, 20]]);
    this.school_code = new FormField("", true, [Validations.EMPTY]);
    this.branch_code = new FormField("", true, [Validations.EMPTY]);
    this.emp_id = new FormField("", true, [Validations.EMPTY], this.staffIdRequired);
    this.student_id = new FormField("", true, [Validations.EMPTY], this.studentIdRequired);
  }
  staffIdRequired() {
    return this.selectedTab.value == 1;
  }
  studentIdRequired() {
    return this.selectedTab.value == 2;
  }
}

export class LoginModel extends BaseModel{
  username: FormField;
  password: FormField;
  constructor() {
    super();
    this.username = new FormField("", true, [Validations.EMPTY]);
    this.password = new FormField("", true, [Validations.EMPTY]);
  }
}
